import { Router } from '@angular/router'
import { DOCUMENT, NgTemplateOutlet } from '@angular/common'
import {
  Component,
  OnInit,
  TemplateRef,
  Renderer2,
  ChangeDetectionStrategy,
  input,
  inject,
  output,
  signal,
} from '@angular/core'

import { Color, State } from '../morph-button/morph-button.enums'
import { MorphButton } from '../morph-button/morph-button'
import { ClassValue, flattenClassValue } from '@core/utils/classes.utils'

@Component({
  selector: 'bo-modal',
  templateUrl: './modal.html',
  styleUrls: ['./modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, MorphButton],
})
export class Modal implements OnInit {
  #document = inject<Document>(DOCUMENT)
  readonly #renderer = inject(Renderer2)
  readonly #router = inject(Router)

  readonly size = input<string>(undefined)
  readonly type = input<string>(undefined)
  readonly extraClasses = input<ClassValue>(undefined)
  readonly backgroundImage = input<string>(undefined)
  readonly hasCloseButton = input(true)
  readonly closeOnBackdrop = input(false)
  readonly inlineMode = input(false)
  readonly routeOnClose = input<string>(undefined)
  readonly modalHeader = input<TemplateRef<any>>(undefined)
  readonly modalBody = input<TemplateRef<any>>(undefined)
  readonly modalFooter = input<TemplateRef<any>>(undefined)

  readonly onClose = output<boolean>()
  readonly onOpen = output<boolean>()

  readonly isOpen = signal(false)
  readonly isInline = signal(false)
  sizeClass = ''
  typeClass = ''
  State = State
  Color = Color

  ngOnInit() {
    const size = this.size()
    if (size) {
      this.sizeClass = `c-modal--${size}`
    }

    const type = this.type()
    if (type) {
      this.typeClass = `c-modal--${type}`
    }

    this.isInline.set(this.inlineMode())
  }

  get extraClassesString(): string {
    return flattenClassValue(this.extraClasses())
  }

  openModal() {
    this.isOpen.set(true)
    this.isInline.set(false)
    this.#renderer.addClass(this.#document.body, 'document--modal')
    this.onOpen.emit(this.isInline())
  }

  closeModal() {
    this.isOpen.set(false)
    this.isInline.set(this.inlineMode())
    this.#renderer.removeClass(this.#document.body, 'document--modal')
    const routeOnClose = this.routeOnClose()
    if (routeOnClose) {
      void this.#router.navigateByUrl(routeOnClose)
    }
    this.onClose.emit(this.isInline())
  }
}
